// 定义项目请求相关地址
function CreateLocal() {
  var localhost = {};

  var env = /manager.changingstudy.com/.test(window.location.hostname)?'production':'development';

  switch (env) {
    case 'development':
      // localhost.ajaxurl = 'https://ms.changingstudy.com/gateway';
      localhost.ajaxurl = 'http://192.168.100.21:5555';
      // localhost.ajaxurl = 'http://192.168.1.100:5555';
      localhost.appurl = 'https://totest.changingstudy.com';
      localhost.rooturl = 'https://pay.changingstudy.com';
      break;
    case 'production':
      // localhost.ajaxurl = 'https://study.changingstudy.com/studygame';
      localhost.ajaxurl = 'https://ms.changingstudy.com/gateway';
      localhost.appurl = 'https://to.changingstudy.com';
      localhost.rooturl = 'https://study.changingstudy.com';
      break;
  }
  localhost.appId = "wx9cc1154783e85688";
  localhost.appType = 0;
  return localhost;
}

//process.env.NODE_ENV
export default CreateLocal();



// WEBPACK FOOTER //
// ./src/utils/localhost.js